<div class="app-dialog" [class.app-dialog--no-body]="!hasBody">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ data.title | translate }}</h2>
    </div>
    <button mat-icon-button type="button" [mat-dialog-close]="false" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body" *ngIf="hasBody">
    <p class="confirmation-dialog__body" *ngIf="data.body">
      {{ data.body | translate : (data.translateParams || {}) }}
    </p>
    <p class="confirmation-dialog__additional-info" *ngIf="data.additionalInfo">
      {{ data.additionalInfo | translate : (data.translateParams || {}) }}
    </p>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" [mat-dialog-close]="false">
      {{ 'cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="button" [mat-dialog-close]="true">
      {{ (data.confirmButton || 'yes') | translate }}
    </button>
  </footer>
</div>
